import { createSlice, current } from "@reduxjs/toolkit";

export const userTypesSlice = createSlice({
  name: "userTypes",
  initialState: {
    list : [],
  },
  reducers: {
    setUserTypes: (state, action) => {
      if(action.payload) state.list = action.payload
    },
    updateUserType: (state, action) => {
      if(action.payload) state.list = state.list.map((userType) =>
      userType.id == action.payload.id ? action.payload : userType
      );
    },

    // To insert only one user type, use:
    addUserType: (state,action)=>{
      let userTypeExists= state.list.find(x => x.id == action.payload.id)
      if(userTypeExists) console.log("User Type exists in Redux state, DROP: " + action.payload.id);
      if(action.payload && !userTypeExists) state.list.push(action.payload)
    },

    // To insert mmultiple userTypes, use:
    addUserTypes: (state,action ) => {

      // Avoid duplicates
      let noDuplicate = action.payload.map( (incomingUserType) => {
        if(!current(state.list).find(existentUserType => existentUserType.id == incomingUserType.id)){// Find if this id already exist in the state
          // If not return that userType that do not exist as result of map and save it in noDuplicate
          return incomingUserType 
        }
      }).filter(item=>item!== undefined)// avoid saving undefined items

      let updatedList = [...current(state.list),...noDuplicate];
      console.log("Updating whiteList: ", updatedList)
      // update the actual state
      state.list = updatedList
    }
  }
});

export default userTypesSlice.reducer

export const selectAllUserTypes = state=>state.userTypesSlice.list

export const {setUserTypes, updateUserType, addUserType, addUserTypes} = userTypesSlice.actions